module.exports = __webpack_public_path__ + "media/clients/b-9-6159d8a3.png";